import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import AgentNavbar from "../../component/AgentNavbar";  
import axios from "axios";
import { baseurl } from "../../component/Baseurl";

function MyWalletAgent() {
  const agentid = localStorage.getItem("agent_id");
  const [transactions, setTransactions] = useState([]);
  const [walletBalance, setWalletBalance] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!agentid) {
      setError("Agent ID not found in local storage.");
      setLoading(false);
      return;
    }

    const fetchTransactions = async () => {
      try {
        const response = await axios.get(`${baseurl}/GetWalletTransactionsForAgent/${agentid}`);
        setTransactions(response.data.transactions);
        setWalletBalance(response.data.wallet_balance);
      } catch (error) {
        setError("Failed to fetch wallet transactions. Please try again.");
        console.error("API Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [agentid]);

  return (
    <>
      <AgentNavbar />
      <div className="bgagent">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="text-start agenth1 pt-3 font4">
              {/* <span>Welcome to Dashboard</span> */}
            </h1>
          </div>

          <div className="text-end d-flex justify-content-end">
              <Link to="/agent/request-top-up" className="btn3 text-white mb-3">Request Top Up</Link>
            </div>


          <div className="crdmain">
            <h3 className="title text-start">💰 Wallet Balance: ₹{walletBalance}</h3>

            {loading ? (
              <p>Loading transactions...</p>
            ) : error ? (
              <p className="text-danger">{error}</p>
            ) : transactions.length === 0 ? (
              <p>No transactions found.</p>
            ) : (
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead className="table-dark">
                    <tr>
                      <th>#</th>
                      <th>Amount (₹)</th>
                      <th>Transaction Type</th>
                      <th>Reason</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactions.map((transaction, index) => (
                      <tr key={transaction.id}>
                        <td>{index + 1}</td>
                        <td>{transaction.amount}</td>
                        <td className={transaction.transaction_type === "credit" ? "text-success" : "text-danger"}>
                          {transaction.transaction_type}
                        </td>
                        <td>{transaction.transaction_reason}</td>
                        <td>{new Date(transaction.created_at).toLocaleString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default MyWalletAgent;
